/* eslint-disable */
/**
 * Neptune TP API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    QuizQuestionTemplateDto,
    QuizQuestionTemplateDtoFromJSON,
    QuizQuestionTemplateDtoToJSON,
} from './';

/**
 * 
 * @export
 * @interface QuizTemplateDto
 */
export interface QuizTemplateDto {
    /**
     * 
     * @type {string}
     * @memberof QuizTemplateDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof QuizTemplateDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof QuizTemplateDto
     */
    description: string;
    /**
     * 
     * @type {number}
     * @memberof QuizTemplateDto
     */
    durationMinutes: number;
    /**
     * 
     * @type {number}
     * @memberof QuizTemplateDto
     */
    version: number;
    /**
     * 
     * @type {Array<QuizQuestionTemplateDto>}
     * @memberof QuizTemplateDto
     */
    questions?: Array<QuizQuestionTemplateDto> | null;
}

export function QuizTemplateDtoFromJSON(json: any): QuizTemplateDto {
    return {
        'id': json['id'],
        'name': json['name'],
        'description': json['description'],
        'durationMinutes': json['durationMinutes'],
        'version': json['version'],
        'questions': !exists(json, 'questions') ? undefined : (json['questions'] as Array<any>).map(QuizQuestionTemplateDtoFromJSON),
    };
}

export function QuizTemplateDtoToJSON(value?: QuizTemplateDto | null): any {
    if (value == undefined) {
        return undefined;
    }
    return {
        'id': value.id,
        'name': value.name,
        'description': value.description,
        'durationMinutes': value.durationMinutes,
        'version': value.version,
        'questions': value.questions === undefined ? undefined : (value.questions as Array<any>).map(QuizQuestionTemplateDtoToJSON),
    };
}


